import axiosInstance from "@/lib/axios";
import type { LoginResponse } from "@/types";

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await axiosInstance.post<LoginResponse>("login/", { email, password });
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      const refresh = localStorage.getItem("refreshToken");
      if (refresh) {
        await axiosInstance.post("logout/", { refresh });
      }
    } finally {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    }
  },
};
